export default "__VITE_ASSET__BYprhiqq__"